import { Box, Flex, Text } from '@chakra-ui/react';
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons';
import { Button, OutlineCard } from '@morressier/alembic';
import { useState } from 'react';
import EmptyState from 'src/components/Submission/BoardMemberReviewsTab/EmptyState';
import ReviewResponseModal from './ReviewResponseModal';
import { formatDate } from 'src/utils/date';
import { IRevisionRound } from '@publishing-engine/domain/models';

const AuthorSubmittedResponse = ({
  revisionRound
}: {
  revisionRound: IRevisionRound;
}) => {
  const [showReviewResponse, setShowReviewResponse] = useState(false);

  const onClose = () => setShowReviewResponse(false);

  const onOpen = () => setShowReviewResponse(true);

  const submittedResponseDate = revisionRound.dateCompleted
    ? formatDate(new Date(revisionRound.dateCompleted!))
    : null;

  const responseText = (
    <>
      Your latest response to the Reviewer comments was submitted
      {submittedResponseDate && (
        <>
          {' on '}
          <br />
          {submittedResponseDate}
        </>
      )}
      .
    </>
  );

  return (
    <OutlineCard padding={4} width="100%">
      <Flex flexDirection={'column'}>
        <Text textStyle="headingSection">Your Response</Text>
        <EmptyState
          title="Response Submitted"
          subTitle={
            <Flex direction="column" gap={2}>
              <Text>{responseText}</Text>
              <Box marginTop={2}>
                <Button variant="secondary" onClick={onOpen}>
                  Review Response
                </Button>
              </Box>
            </Flex>
          }
          bgColor="successSecondaryFill"
          borderRadius={8}
          icon={faCircleCheck}
        />
      </Flex>
      {showReviewResponse && (
        <ReviewResponseModal isOpen={showReviewResponse} onClose={onClose} />
      )}
    </OutlineCard>
  );
};

export default AuthorSubmittedResponse;
